// extracted by mini-css-extract-plugin
export default {"container":"src-constrains-SiderErrorController-SiderNameWithErr-css-module__container--tPjcH","icon":"src-constrains-SiderErrorController-SiderNameWithErr-css-module__icon--KlInJ"};